const number = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const calculateAmount = (quantity, unitPrice) =>
  Math.round(number(quantity) * number(unitPrice) * 100) / 100;

export const calculateAcceptanceQuantities = ({
  subcontractQuantity,
  reportedQuantity,
  acceptedQuantity,
}) => {
  const contract = number(subcontractQuantity);
  const reported = number(reportedQuantity);
  const accepted = number(acceptedQuantity);

  return {
    rejectedQuantity: Math.max(reported - accepted, 0),
    remainingQuantity: Math.max(contract - accepted, 0),
  };
};

export const calculateRemainingPercentage = (totalQuantity, completedQuantity) => {
  const total = number(totalQuantity);
  if (total <= 0) return 0;
  return Math.max(0, Math.min(100, ((total - number(completedQuantity)) / total) * 100));
};

export const calculateAcceptance = (item, reportedQuantity, acceptedQuantity) => ({
  ...calculateAcceptanceQuantities({
    subcontractQuantity: item?.subcontractQuantity,
    reportedQuantity,
    acceptedQuantity,
  }),
  acceptanceAmount: calculateAmount(acceptedQuantity, item?.unitPrice),
});

